import React from 'react';

function PublicLayout({ children }) {
  return <div className="public-layout">{children}</div>;
}

export default PublicLayout;